import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components_CO/Header";
import OurFeatures from "../../components_CO/OurFeatures";
import HomeSlider from "../../components_CO/HomeSlider";
import OurServices from "../../components_CO/OurServices";
import FeaturedProducts from "../../components/FeaturedProducts";
import BrandLogoSlider from "../../components/BrandLogoSlider";
import Footer from "../../components_CO/Footer";
import Modal from 'react-bootstrap/Modal';
import CostCenterAndCatalog from '../../components/Dashboard/CostCenterAndCatalog';
import ActiveCatalogue from '../../components_CO/ActiveCatalogue/ActiveCatalogue'
import { useSelector, useDispatch } from 'react-redux'
import * as AuthVerify from '../../lib/common';
import './Home.styles.css';
import HomeCategory from "../../components_CO/HomeCategory"
import { Container, Row, Col } from 'react-bootstrap';

const Home_CO = () => {

	const [showCCaCModel, setShowCCaCModel] = useState(false);

	const compare = useSelector(state => state.compare);
	const dispatch = useDispatch();

	useEffect(() => {
		var userDetails = AuthVerify.getUser();
		if (userDetails?.ccacNotNotified && userDetails.role == 'Corporate') {
			if (AuthVerify.getPermissions("CostCenter")?.menuaccess)
				setShowCCaCModel(true);
			userDetails.ccacNotNotified = false;
			AuthVerify.setSession(userDetails);
		}
	}, []);

	return (
		<div>
			<Helmet>
				<title>ComOffice Home</title>
				<meta name="description" content="E-Commerce" />
				<meta property="og:image" content="%PUBLIC_URL%" />
				<meta property="og:title" content="E-Commerce" />
				<meta name="title" content="E-Commerce" />
				<meta property="og:description" content="E-Commerce" />
				<meta property="og:url" content="%PUBLIC_URL%" />
			</Helmet>
			<Header reducer={compare} dispatch={dispatch} />
			<ActiveCatalogue reducer={compare} dispatch={dispatch}/>
			<div className = "homecontainer">
				<Row style={{ display: "flex" }}>
					<Col style={{ paddingTop: "20px" }} className="hidden-xs">
						<HomeCategory></HomeCategory>
					</Col>
					<Col>
						<Container fluid>
							<HomeSlider reducer={compare} dispatch={dispatch} />
							<OurFeatures reducer={compare} dispatch={dispatch} />
							<FeaturedProducts reducer={compare} dispatch={dispatch} />
							<OurServices reducer={compare} dispatch={dispatch} />
						</Container>
					</Col>
				</Row>
			</div>
			<Footer reducer={compare} dispatch={dispatch} displayFooterTop={""} />

			{/* <ActiveCatalogue reducer={compare} dispatch={dispatch}/> 
			<OurFeatures reducer={compare} dispatch={dispatch}/>
			<HomeSlider reducer={compare} dispatch={dispatch}/>
			<FeaturedProducts reducer={compare} dispatch={dispatch}/>
			<OurServices reducer={compare} dispatch={dispatch}/>
			<BrandLogoSlider reducer={compare} dispatch={dispatch}/>
			<Footer reducer={compare} dispatch={dispatch} socket={socket}/> */}

			<Modal show={showCCaCModel} dialogClassName="modal-90w" centered={true} animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowCCaCModel(false)}>
				<Modal.Header closeButton={false}>
					<Modal.Title>Update your Cost Center and Catalog</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ textAlign: "center" }}>
					<CostCenterAndCatalog />
				</Modal.Body>
				<Modal.Footer>
					<div className="">
						<button
							className="button btn-proceed-checkout btn-danger"
							title="Proceed to Checkout"
							type="button"
							onClick={() => setShowCCaCModel(false)}
							style={{
								marginRight: "10px",
								padding: "10px"
							}}
						>
							<span>Close</span>
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</div>

	);

};
export default Home_CO;
